var path = 'src/app/patients/ins/relapses.html';
var html = "<h1 class=page-header>Relapses</h1> <div ins-relapses-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/ins/relapses.html
 ** module id = 500
 ** module chunks = 0
 **/